import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Project() {
  const location = useLocation();
  const { t } = useTranslation();

  // زبان از سگمنت اول URL
  const seg = location.pathname.split("/")[1];
  const lang = seg === "fa" || seg === "en" ? seg : "en";

  useEffect(() => {
    const targets = document.querySelectorAll(".fade-in");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const items = t("project.items", { returnObjects: true });

  return (
    <section
      className="col-xs-12 noPadding"
      dir={lang === "en" ? "ltr" : "rtl"}
    >
      <div className="col-xs-12 col-md-9 noPadding">
        <div className="servivehero">
          <h2>{t("project.title")}</h2>

          {Array.isArray(items) &&
            items.map((text, i) => (
              <p key={i} className="fade-in from-right delay-2">
                {text}
              </p>
            ))}

          {/* <div className="serviceset fade-in from-right delay-3">
            فرض: تصویر در public/assets است 
            <img
              src="/assets/seetings.png"
              alt={t("project.imageAlt")}
              loading="lazy"
            />
          </div>*/}
        </div>
      </div>
    </section>
  );
}
